module.exports = __webpack_public_path__ + "static/media/cogs.371a3a0d.svg";